export const companyProfile = [
  { label: "会社名", value: "株式会社小林建設" },
  { label: "所在地", value: "〒344-0021 埼玉県春日部市大場207-1" },
  { label: "電話番号", value: "048-795-6298" },
  { label: "メール", value: "kobayashikensetu@icloud.com" },
  { label: "営業時間", value: "9:00〜18:00" },
  { label: "定休日", value: "年中無休（現場状況等により変動あり）" },
  { label: "設立", value: "2021年" },
  { label: "事業内容", value: "住宅リフォーム・建設業（屋根工事・塗装工事 ほか）／不用品回収・遺品整理" },
];

export const qualifications = [
  { icon: "ri-shield-check-line", text: "建設業許可 取得済み" },
  { icon: "ri-building-2-line", text: "許可業種：屋根工事・板金工事" },
  { icon: "ri-file-shield-2-line", text: "その他建設関連の資格を保有" },
];

export const companyStrengths = [
  "本業は春日部市の建設・リフォーム会社",
  "屋根工事・塗装工事を中心に、住宅リフォームを手がけています",
  "片付けからその後の原状回復・リフォームまで一社で対応",
  "会社所在地・電話・ホームページも公開しています",
];